module.exports = __webpack_public_path__ + "img/step-prev.23ce58c2.svg";